import axios from  '../plugins/axios';

class HealthCheckService {
    fetch(params) {
      return axios.post("/api/v2/healthcheck", params);
    }
  
    // other CRUD methods
}

export default new HealthCheckService();